import OrderedPageFilter from 'application/commons/orderedPageFilter'
import PagedFilter from 'application/commons/pagedFilter'
import { adminHttpClient } from '../../../commons/adminHttpClient'

export interface Transaction {
  date: Date
  eventType: {
    id: number
    name: string
  }
  amount: number
  availableAllowance: number
}

const getTransactionsApi = (planPeriodId: string): Promise<any> => {
  return adminHttpClient.get(`/TransactionsHistory/${planPeriodId}`, {})
}

export default getTransactionsApi
